import React from "react";
import ErrorBoundary from "../../../lib/ErrorBoundary";
import { TileView } from "./tileView/TileView";
import { Toolbar } from "./toolbar/Toolbar";
import { ListView } from "./listView/ListView";
import { _t } from "../../../app/i18n/i18n";
import { PaginationControl } from "./pagination/PaginationControl";
import { NumberOfSearchResults } from "./toolbar/parts/NumberOfSearchResults";
import { useSelector, useDispatch } from "react-redux";
import { setPreference } from "pages/preferences/preferencesActions";
import { PAGINATION_POS, VIEW } from "../../../redux/slices/api/initialisePreferences";
import { AdvertBanner } from "pages/ads/adverts/AdvertBanner";
import { useHasPreference } from "pages/preferences/api/useGetPreferences";
import { LoadingSpinner } from "lib/Spinner";

export function ViewLayout({ publications = [], data = {}, hideAds = false, hideToolbar = false }) {
  const viewMode = useSelector((state) => state.preferences[VIEW])[0];
  const dispatch = useDispatch();
  const setViewMode = (mode) => dispatch(setPreference({ key: VIEW, value: mode }));
  const records = data.TotalRecords || data?.[4] || 0;
  const isPaginationTop = useHasPreference(PAGINATION_POS, "Top & Bottom");
  const aggregations = data?.[3];
  const isLoading = data?.[1];

  if (isLoading) return <LoadingSpinner />;

  return (
    <ErrorBoundary>
      {!hideToolbar && <Toolbar viewMode={viewMode} setViewMode={setViewMode} aggregations={aggregations} />}
      {!hideAds && <AdvertBanner />}
      {isPaginationTop && <PaginationControl records={records} />}
      {viewMode === "List" ? <ListView publications={publications} /> : <TileView publications={publications} />}
      <NumberOfSearchResults number={records} className="text-center" />
      <PaginationControl records={records} />
    </ErrorBoundary>
  );
}

export const NoPublicationsFound = () => <center className="m-5 text-muted">{_t("No Publications Found")}</center>;
